export const ADD_PLAYLIST = 'ADD_PLAYLIST'
export const GET_PUBLIC_PLAYLISTS = 'GET_PUBLIC_PLAYLISTS'
export const ADD_SONG_TO_PLAYLIST = 'ADD_SONG_TO_PLAYLIST'
export const GET_PLAYLIST = 'GET_PLAYLIST'
export const EDIT_PLAYLIST = 'EDIT_PLAYLIST'
export const DELETE_PLAYLIST = 'DELETE_PLAYLIST'
export const REMOVE_SONG_FROM_PLAYLIST = 'REMOVE_SONG_FROM_PLAYLIST'